import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const ExportUnidades = (unidades, nombreCedis) => {
  if (!unidades)
    return Swal.fire("Sin datos", "No hay información disponible", "info");

  const { enRuta = {}, disponible = {} } = unidades;

  // ======== FORMATEO DE "EN RUTA" ==========
  const enRutaData =
    enRuta.unidades?.map((u) => {
      const viaje = u.viajes?.[0] || {};
      const bitacora = viaje.bitacora_monitorista?.[0] || {};
      const coordenadas = u.coordenadas || "00.00,00.00";
      const fecha_posicion = u.fecha_posicion || "N/A";
      const ruta = u.viajes[0].ruta
        ? u.viajes[0].ruta.map((d) => d.tienda.tienda_nombre).join(", ")
        : "N/A";

      return {
        // "Unidad ID": u.unidad_id,
        "Número Unidad": u.unidad_numero,
        Centro: u.cedi?.nombre_cedis || "",
        "Último Estatus": bitacora.status?.nombre || "",
        "Fecha/Hora Último Evento": bitacora.bitacora_fecha_hora || "",
        Dirección: bitacora.direccion || "",
        "Tienda Destino": ruta,
        "Coordenadas Plataforma": coordenadas || "",
        "Fecha/Hora Plataforma Reporte": fecha_posicion || "",
      };
    }) || [];

  // ======== FORMATEO DE "DISPONIBLES" ==========
  const disponibleData =
    disponible.disponibles?.map((u) => ({
      //   "Unidad ID": u.unidad_id,
      "Número Unidad": u.unidad_numero,
      VIN: u.unidad_vin || "",
      Centro: u.cedi?.nombre_cedis || "",
      Coordenadas: u.coordenadas || "",
      "Fecha Posición": u.fecha_posicion || "",
    })) || [];

  // ======== CREAR LIBRO Y HOJAS ==========
  const wb = XLSX.utils.book_new();
  const wsEnRuta = XLSX.utils.json_to_sheet(enRutaData);
  const wsDisponibles = XLSX.utils.json_to_sheet(disponibleData);

  XLSX.utils.book_append_sheet(wb, wsEnRuta, `En ruta (${enRuta.total || 0})`);
  XLSX.utils.book_append_sheet(
    wb,
    wsDisponibles,
    `Disponibles (${disponible.total || 0})`
  );

  // ======== EXPORTAR ==========
  XLSX.writeFile(
    wb,
    `unidades_${nombreCedis} ${new Date().toISOString().slice(0, 10)}.xlsx`
  );
};

export default ExportUnidades;
